module.exports = __webpack_public_path__ + "static/media/satosphere.76ad186b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/PL90/satosphere.jpg
// module id = 170
// module chunks = 0